// extracted by mini-css-extract-plugin
export default {"page-footer":"index_page-footer__ZcGcM"};